import { render, staticRenderFns } from "./SlideExpiredCrewMonth.vue?vue&type=template&id=6a61254a"
import script from "./SlideExpiredCrewMonth.vue?vue&type=script&lang=js"
export * from "./SlideExpiredCrewMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports